import React, {Component} from "react";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import TabDataPersonal from "./tabDataPersonal/tabDataPersonal";
import TabFoto from "./tabFoto/tabFoto";
import TabDataUnit from "./tabDataUnit/tabDataUnit";
import TabPaketPenjualan from "./tabPaketPenjualan/tabPaketPenjualan";
import TabTransaksi from "./tabTransaksi/tabTransaksi";
import TabDelivery from "./tabDelivery/tabDelivery";
import TabKeterangan from "./tabKeterangan/tabKeterangan";

class FakturJualDetailContent extends Component {

    listStateCanEditDataPersonal = [
        "FJ_DRAFT",
        "FJ_SUBMITTED",
        "WAREHOUSE_PDI",
        "ADH_DELIVERY",
    ];
    
    constructor(props) {
      super(props);
      this.state = {
        enhancedState: props.state,
        enhancedStatePembeli: props.state
      }
    }

    componentDidMount() {
        if(this.props.tab === 'NOS'){
            this.updateIsEditableState()
        }
     }

    componentDidUpdate(prevProps, prevState) { 
        if(prevProps.fjState !== this.props.fjState){
            this.updateIsEditableState()
        }
    }

    updateIsEditableState = () => {
      const { state, isDraft, fjState } = this.props;

      let finalEditable = state.isEditable;
      let finalEditablePembeli = state.isEditable;
      let editableSpesificField = false;

      if (state.isEditable && state.selectedData) {
        finalEditable = isDraft;
        finalEditablePembeli = this.listStateCanEditDataPersonal.includes(fjState);
        editableSpesificField = true;
      } else if (!state.isEditable && state.selectedData) {
        finalEditable = false;
        finalEditablePembeli = state.isEditable;
      } else{
        editableSpesificField = true
      }

      this.setState({
        enhancedState: {
          ...state,
          isEditable: finalEditable,
          isEditableSpesificField: editableSpesificField,
        },
        enhancedStatePembeli: {
          ...state,
          isEditable: finalEditablePembeli,
        },
      });
    };


    render() {
        const { enhancedState, enhancedStatePembeli } = this.state;
        return (
            <>
                <Tabs>
                    <TabList>
                        <Tab id="button_navigate_data_pembeli">Data Pembeli</Tab>
                        <Tab id="button_navigate_data_pemilik">Data Pemilik</Tab>
                        <Tab id="button_navigate_data_foto_kk_ktp">Foto KK & KTP</Tab>
                        <Tab id="button_navigate_data_unit">Data Unit</Tab>
                        <Tab id="button_navigate_paket_penjualan">Paket Penjualan</Tab>
                        <Tab id="button_navigate_transaksi">Transaksi</Tab>
                        <Tab id="button_navigate_delivery">Delivery</Tab>
                        <Tab id="button_navigate_referal">Referal</Tab>
                        <Tab id="button_navigate_keterangan">Keterangan</Tab>
                    </TabList>
                    <TabPanel>
                        <TabDataPersonal {...this.props} tab="dataPembeli" state={enhancedStatePembeli}/>
                    </TabPanel>
                    <TabPanel>
                        <TabDataPersonal {...this.props} tab="dataPemilik" state={enhancedState}/>
                    </TabPanel>
                    <TabPanel>
                        <TabFoto {...this.props} tab="foto" state={enhancedState}/>
                    </TabPanel>
                    <TabPanel>
                        <TabDataUnit {...this.props} tab="dataUnit" state={enhancedState}/>
                    </TabPanel>
                    <TabPanel>
                        <TabPaketPenjualan {...this.props} tab="dataPackage" state={enhancedState}/>
                    </TabPanel>
                    <TabPanel>
                        <TabTransaksi {...this.props} tab="dataTransaction" state={enhancedState}/>
                    </TabPanel>
                    <TabPanel>
                        <TabDelivery {...this.props} tab="dataDelivery" state={enhancedState}/>
                    </TabPanel>
                    <TabPanel>
                        <TabDataPersonal {...this.props} tab="dataReferral" state={enhancedState}/>
                    </TabPanel>
                    <TabPanel>
                        <TabKeterangan {...this.props} tab="dataNote" state={enhancedState}/>
                    </TabPanel>
                </Tabs>
            </>
        )
    }
}

export default FakturJualDetailContent;